import { useEffect, useState } from "react";
import { Flame, Trophy } from "lucide-react";
import { api } from "../lib/api";

export default function StreakLeaderboard({ compact = false }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/community/streaks/leaderboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <section className="rounded-2xl border border-slate-800 bg-[#131722] p-4" data-testid="streak-leaderboard">
      <div className="flex items-center gap-2 mb-3"><Flame className="w-4 h-4 text-orange-300" /><h3 className="font-semibold text-sm">Top on-time streaks</h3><span className="ml-auto text-[10px] font-mono text-slate-500">{d.total_drivers} on a streak</span></div>
      {!d.leaders.length && <p className="text-xs text-slate-500" data-testid="streak-leaderboard-empty">No active streaks yet — finish every pickup inside its window this week to start one.</p>}
      <ol className="space-y-1.5">
        {d.leaders.map((r) => (
          <li key={r.user_id} data-testid={`streak-row-${r.rank}`} className={`flex items-center gap-2.5 text-sm rounded-lg px-2 py-1.5 ${r.me ? "bg-cyan-400/10 border border-cyan-400/30" : ""}`}>
            <span className={`w-5 text-center font-mono text-xs ${r.rank <= 3 ? "text-amber-300" : "text-slate-500"}`}>{r.rank <= 3 ? <Trophy className="w-3.5 h-3.5 inline" /> : r.rank}</span>
            <span className="flex-1 truncate">{r.name}{r.me && <span className="text-cyan-300 text-xs ml-1">(you)</span>}</span>
            {r.tier && !compact && <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-slate-800 text-amber-200">{r.tier}</span>}
            <span className="font-mono text-xs text-orange-300">{r.weeks}w</span>
          </li>
        ))}
      </ol>
      {d.me && !d.leaders.some((r) => r.me) && <p className="text-xs text-slate-500 mt-2" data-testid="streak-leaderboard-me">You: {d.me.weeks} week{d.me.weeks === 1 ? "" : "s"} — keep going to make the board.</p>}
    </section>
  );
}
